import sdk from '@/sdk';
import dayjs from 'dayjs';
import {memo, useEffect, useRef, useState} from 'react';
import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import GuideBaseWithLuffy from '../GuideBaseWithLuffy';

interface IDocSecondGuide {
    children: any;
}

const DocSecondGuide: React.FC<IDocSecondGuide> = ({children}) => {
    const isRead =
        sdk.as.user?.settings?.newGuide?.knowledgeCoinDocSecondGuideIsRead;
    const [isShow, changeIsShow] = useState(false);
    const HomeKnowLedgeGuideRef = useRef<HTMLDivElement>(null);
    const target = useRef(document.querySelector('.baidu__editor__content'));

    const {setShouldObserve} = useIntersectionObserver(HomeKnowLedgeGuideRef.current as HTMLElement, {
        successCallback: () => changeIsShow(true),
    });

    useEffect(() => {
        if (isShow) {
            const timer = setTimeout(async () => {
                await sdk.as.updateNewGuide({
                    knowledgeCoinDocSecondGuideIsRead: true,
                });
                clearTimeout(timer);
                changeIsShow(false);
                setShouldObserve(false);
                localStorage.removeItem('knowledge_guide_status');
            }, 3000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShow]);


    async function checkShouldShowNewGuide() {
        // 说明是第一次出现
        if (isRead) {
            return;
        }
        const knowledgeGuideStatus = localStorage.getItem('knowledge_guide_status') || '';
        // 如果没有存储
        if (!knowledgeGuideStatus) {
            return;
        }
        const {timeCache} = JSON.parse(knowledgeGuideStatus) || {};
        // 如果当前时间晚于当日了 那么可以呈现
        if (!(timeCache && dayjs().isAfter(`${timeCache} 23:59:59`))) {
            return;
        }

        // 通过校验 可显示
        setShouldObserve(true);
    }
    useEffect(() => {
        checkShouldShowNewGuide();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return <GuideBaseWithLuffy
        target={HomeKnowLedgeGuideRef.current as any}
        placement={'right'}
        content="点击可给ta赠送知识币哦～"
        visible={isShow}
        onChangeVisible={changeIsShow}
        eventsEnabled
        name="docSecondGuide"
        portalContainer={target.current}
    >
        <div ref={HomeKnowLedgeGuideRef}>{children}</div>
    </GuideBaseWithLuffy>;
};

export default memo(DocSecondGuide);
